import React from "react";
import "./ExperienceSec2.css";
import { Button, Card, Carousel, Image, Stack } from "react-bootstrap";
import { map } from "lodash";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
export const ExperienceSec2 = ({ data }) => {
    return (
        <>
            <div className="expsec2 standard-padding">
                <h1 className="mb-4 heading">What Would You Like To Do?</h1>
                <Stack className="expsec2-container">
                    {map(data, exp => (
                        <div key={exp.BCategoryId} className="expsec2-card-container">
                            <Experience data={exp} />
                        </div>
                    ))}
                </Stack>
            </div>
        </>
    )
}

const Experience = ({ data }) => {
    const navigate = useNavigate()

    return (
        <Card className="expsec2-card">
            <div className="expsec2-image-container" >
                <Image className="expsec2-card-image" src={data.ImagePath} alt={data.AlternateText} />
            </div>
            <Card.Body style={{ padding: 0, width: "100%" }}>
                <Stack className="expsec2-card-content">
                    <div>
                        <p className="expsec2-card-title">{data.BCategoryName}</p>
                        <p className="expsec2-card-text">{data.ShortDescription}</p>
                    </div>
                    <Button
                        className="expsec2-card-button"
                        onClick={() => navigate(`/experiences/${data.Slug}`, {
                            state: {
                                BlogCategoryId: data.BCategoryId
                            }
                        })}
                        style={{ display: "flex", alignItems: "center", justifyContent:"center", gap: "6px" }}
                    >
                        See Details  <FiArrowRight size={18} />
                    </Button>
                </Stack>
            </Card.Body>
        </Card>
    )
}